import { render, staticRenderFns } from "./SettingsPaymentMethodEdit.vue?vue&type=template&id=38bd0c68"
import script from "./SettingsPaymentMethodEdit.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentMethodEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports